var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-character-mapping-chart padding-20"},[_c('v-chart',{staticClass:"chart chart-network",attrs:{"options":_vm.options}}),(_vm.loading)?_c('g-loading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }